// navigation-item.component.ts
import { Component, Input } from '@angular/core';

export interface NavigationItem {
  url_tree: string;
  icon: string;
  title: string;
  sub_navigations: NavigationItem[];
}

@Component({
  selector: 'app-navigation-item',
  template: `
    <button
      class="nav__list-item text-truncate"
      [routerLink]="item.url_tree"
      routerLinkActive="active"
    >
      <span class="nav__label">{{ item.title | translate }}</span>
      <mat-icon>{{ item.icon }}</mat-icon>
    </button>
    @if (item.sub_navigations && item.sub_navigations.length) {
      @for (subItem of item.sub_navigations; track subItem) {
        <app-navigation-item [item]="subItem"></app-navigation-item>
      }
    }
  `,
})
export class NavigationItemComponent {
  @Input() item!: NavigationItem;
}
